import { Text } from "./tailwind/text";
export const ExtractUserMessage = ({ fullError }) => {
  try {
    console.log(fullError)
    if (fullError === "") {
      return;
    }
    var errorObject = fullError;
    if (typeof fullError !== typeof {}) {
      const openBraceIndex = fullError.indexOf("{");
      const closeBraceIndex = fullError.lastIndexOf("}");

      const jsonSubstring = fullError.substring(
        openBraceIndex,
        closeBraceIndex + 1
      );
      errorObject = JSON.parse(jsonSubstring);
    }

    if (errorObject && errorObject.error && errorObject.error.error_user_msg) {
      return (
        <Text>{`${errorObject.error.error_user_title}: ${errorObject.error.error_user_msg}`}</Text>
      );
    } else if (errorObject && errorObject.error && errorObject.error.message) {
      return <Text>{`${errorObject.error.message}`}</Text>;
    } else {
      return <Text>No message available</Text>;
    }
  } catch (error) {
    console.error("Failed to parse error JSON:", error);
    return <p>An error occurred while processing the error details.</p>;
  }
};
